<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <transition
    enter-active-class="transition-opacity duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-300 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
    v-bind="$attrs"
  >
    <slot></slot>
  </transition>
</template>
